export default {
  methods: {
    calculateTileWidth(entity, size, full = false, search = false) {
      if (full === true) {
        return `w-full`;
      }

      let s = `w-1/${size}`;

      if (!search && entity.is_full_width) {
        s = `full w-3/${size}`;

        if (size <= 3) {
          s = 'full w-full';
        }
      }
      return s;
    },
  },
};
